
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Ertigaonrentinnavimumbai() {



const cardData = {
  keyword: "Ertiga On Rent in Navi Mumbai",
  heading: "Skyline Cabs: Ertiga On Rent in Navi Mumbai",
  headingDescription: "Skyline Cabs offers premium Ertiga On Rent in Navi Mumbai for family trips, corporate travel, airport transfers, and long-distance outstation journeys. The Maruti Suzuki Ertiga is known for its spacious 7-seater capacity, fuel efficiency, and smooth ride quality, making it ideal for both city and highway travel. Whether you need ertiga rental navi mumbai for business meetings, ertiga airport pickup navi mumbai for timely transfers, or ertiga cab for outstation navi mumbai for weekend trips, we provide well-maintained vehicles with professional chauffeurs. Our services include transparent pricing, flexible rental packages, and 24x7 availability to ensure comfortable and hassle-free travel across Navi Mumbai and Mumbai.",
  
  top: "Top Places to Visit in Navi Mumbai with Ertiga Rental",

  topPlaces: [
    {
      title: "Central Park Kharghar",
      description: "Central Park Kharghar is one of the largest urban parks in Asia and a prime attraction for families and tourists. Spread across vast greenery, the park offers jogging tracks, amphitheaters, fountains, and peaceful open spaces ideal for relaxation. Visitors often plan weekend outings here with family groups, making Ertiga rental navi mumbai a convenient option due to its spacious seating and luggage capacity. The well-planned infrastructure and scenic hills around the park create a refreshing environment. Skyline Cabs ensures comfortable drop and pickup for visitors exploring this popular location."
    },
    {
      title: "Palm Beach Road",
      description: "Palm Beach Road is one of the most scenic drives in Navi Mumbai, offering breathtaking coastal views and smooth road conditions. It connects Vashi to Belapur and is ideal for comfortable SUV travel. Renting ertiga on rent in navi mumbai makes the journey enjoyable for families traveling together. Evening drives along Palm Beach Road are especially popular due to stunning sunset views and peaceful surroundings."
    },
    {
      title: "Belapur Fort",
      description: "Belapur Fort is a historic landmark reflecting rich Maratha heritage. Surrounded by greenery and offering panoramic city views, it attracts history enthusiasts and adventure seekers. With ertiga hire in navi mumbai, families can comfortably visit this elevated location with ease."
    },
    {
      title: "Pandavkada Waterfalls",
      description: "Pandavkada Waterfalls is a monsoon hotspot located near Kharghar hills. The cascading water and lush surroundings create a serene atmosphere. Families and groups often prefer ertiga cab for outstation navi mumbai for convenient travel during rainy season."
    },
    {
      title: "Seawoods Grand Central Mall",
      description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination offering multiplex, dining, and retail outlets. Spacious vehicles like Ertiga car rental navi mumbai provide comfort for group outings."
    },
    {
      title: "DY Patil Stadium",
      description: "DY Patil Stadium hosts major sports and music events attracting large crowds. Renting ertiga on rent with driver navi mumbai ensures safe and convenient group transport."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a nature reserve perfect for weekend nature trips. With ertiga outstation rental navi mumbai, families can enjoy safe highway travel."
    },
    {
      title: "Nerul Balaji Temple",
      description: "Nerul Balaji Temple offers peaceful spiritual ambiance. Ertiga rental service navi mumbai ensures comfortable family temple visits."
    },
    {
      title: "Utsav Chowk",
      description: "Utsav Chowk is a vibrant landmark in Kharghar known for its architecture and restaurants. Families prefer 24x7 ertiga on rent in navi mumbai for flexible travel planning."
    },
    {
      title: "Rock Garden Nerul",
      description: "Rock Garden offers sea-facing views and calm walking paths. Ertiga airport drop navi mumbai service is often combined with local sightseeing before departures."
    }
  ],

  services: [
    {
      name: "ertiga on rent in navi mumbai",
      description: "Skyline Cabs provides premium ertiga on rent in navi mumbai designed for comfortable family travel, corporate trips, airport transfers, and weekend outings. The Ertiga’s spacious 7-seater configuration, strong AC performance, and fuel efficiency make it ideal for both city and highway journeys. Customers benefit from professional chauffeurs, transparent pricing, and flexible booking durations. Whether you require hourly rentals or full-day bookings, our ertiga on rent in navi mumbai ensures smooth, safe, and reliable travel experience."
    },
    {
      name: "ertiga on rent in navi mumbai",
      description: "Our second listing of ertiga on rent in navi mumbai maintains identical premium standards with well-maintained vehicles and verified drivers. Designed for family comfort, airport transfers, and long-distance travel, this service ensures timely pickup and comfortable seating for up to seven passengers."
    },
    {
      name: "Ertiga rental navi mumbai",
      description: "Ertiga rental navi mumbai service offers flexible booking options including airport transfers, wedding transport, and corporate movement. Skyline Cabs ensures punctual service, clean vehicles, and experienced chauffeurs for smooth travel."
    },
    {
      name: "Ertiga hire in navi mumbai",
      description: "Choose Ertiga hire in navi mumbai for affordable group travel and city rides. The vehicle provides ample luggage space and smooth suspension for long-distance comfort."
    },
    {
      name: "Ertiga car rental navi mumbai",
      description: "Ertiga car rental navi mumbai is ideal for family trips and business travel requiring spacious yet budget-friendly SUV transport."
    },
    {
      name: "ertiga taxi service navi mumbai",
      description: "Professional ertiga taxi service navi mumbai ensures safe and punctual city transportation."
    },
    {
      name: "book ertiga on rent in navi mumbai",
      description: "Easily book ertiga on rent in navi mumbai through our secure booking system with instant confirmation."
    },
    {
      name: "best ertiga on rent navi mumbai",
      description: "Recognized as best ertiga on rent navi mumbai provider for comfort and reliability."
    },
    {
      name: "cheapest ertiga rental navi mumbai",
      description: "Affordable cheapest ertiga rental navi mumbai options without compromising quality."
    },
    {
      name: "ertiga on rent with driver navi mumbai",
      description: "Chauffeur-driven ertiga on rent with driver navi mumbai ensures relaxed and stress-free travel."
    },
    {
      name: "Ertiga rental service navi mumbai",
      description: "Flexible Ertiga rental service navi mumbai for city and outstation trips."
    },
    {
      name: "ertiga airport pickup navi mumbai",
      description: "Timely ertiga airport pickup navi mumbai with flight monitoring support."
    },
    {
      name: "ertiga airport drop navi mumbai",
      description: "Professional ertiga airport drop navi mumbai ensuring punctual departures."
    },
    {
      name: "ertiga outstation rental navi mumbai",
      description: "Comfortable ertiga outstation rental navi mumbai for Pune, Nashik, Shirdi, Kolhapur trips."
    },
    {
      name: "ertiga cab for outstation navi mumbai",
      description: "Reliable ertiga cab for outstation navi mumbai suitable for long-distance highway journeys."
    },
    {
      name: "24x7 ertiga on rent in navi mumbai",
      description: "Round-the-clock 24x7 ertiga on rent in navi mumbai for urgent bookings."
    },
    {
      name: "late night ertiga rental navi mumbai",
      description: "Safe late night ertiga rental navi mumbai for airport and emergency travel."
    },
    {
      name: "ertiga on rent in mumbai",
      description: "Premium ertiga on rent in mumbai service for city and airport transfers."
    },
    {
      name: "ertiga car on rent in mumbai",
      description: "Affordable ertiga car on rent in mumbai for business and family trips."
    },
    {
      name: "ertiga cng on rent in mumbai",
      description: "Fuel-efficient ertiga cng on rent in mumbai for economical travel."
    },
    {
      name: "ertiga on hire in mumbai",
      description: "Reliable ertiga on hire in mumbai with professional chauffeurs."
    },
    {
      name: "ertiga rent per km in mumbai",
      description: "Transparent ertiga rent per km in mumbai pricing for budget-friendly bookings."
    }
  ],

  tableData: [
    ["ertiga on rent in navi mumbai", "Ertiga rental navi mumbai"],
    ["Ertiga hire in navi mumbai", "Ertiga car rental navi mumbai"],
    ["ertiga taxi service navi mumbai", "book ertiga on rent in navi mumbai"],
    ["best ertiga on rent navi mumbai", "cheapest ertiga rental navi mumbai"],
    ["ertiga on rent with driver navi mumbai", "Ertiga rental service navi mumbai"],
    ["ertiga airport pickup navi mumbai", "ertiga airport drop navi mumbai"],
    ["ertiga outstation rental navi mumbai", "ertiga cab for outstation navi mumbai"],
    ["24x7 ertiga on rent in navi mumbai", "late night ertiga rental navi mumbai"],
    ["ertiga on rent in mumbai", "ertiga car on rent in mumbai"],
    ["ertiga cng on rent in mumbai", "ertiga on hire in mumbai"],
    ["ertiga rent per km in mumbai", ""]
  ],

  whychoose: [
    {
      WhyChooseheading: "Spacious 7-Seater Comfort",
      WhyChoosedescription: "The Ertiga offers generous legroom, ample luggage space, and comfortable seating for up to seven passengers, making it ideal for families and corporate groups traveling together."
    },
    {
      WhyChooseheading: "Professional Chauffeur Service",
      WhyChoosedescription: "Experienced, verified drivers ensure safe city and highway travel with punctual pickup and smooth driving standards."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription: "Clear ertiga rent per km in mumbai pricing structure without hidden charges."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Round-the-clock booking support including late night ertiga rental navi mumbai services."
    },
    {
      WhyChooseheading: "Airport Transfer Expertise",
      WhyChoosedescription: "Dedicated ertiga airport pickup navi mumbai and airport drop services."
    },
    {
      WhyChooseheading: "Flexible Rental Packages",
      WhyChoosedescription: "Hourly, daily, outstation, and long-trip options available."
    },
    {
      WhyChooseheading: "Affordable & Fuel Efficient",
      WhyChoosedescription: "CNG and petrol options for economical travel."
    },
    {
      WhyChooseheading: "Customer Satisfaction Focus",
      WhyChoosedescription: "Reliable support team ensuring smooth booking experience."
    }
  ]
}


const faqData = [
    {
        id: 1,
        question: 'How can I book Ertiga On Rent in Navi Mumbai with Skyline Cabs?',
        answer:
            'Booking Ertiga On Rent in Navi Mumbai with Skyline Cabs is quick and convenient. Simply visit our website or mobile app, select Ertiga from the vehicle options, enter your pickup and drop location, choose your date and time, and confirm instantly. You will receive immediate booking confirmation along with driver and vehicle details for complete transparency.',
    },
    {
        id: 2,
        question: 'What is the fare for Ertiga On Rent in Navi Mumbai?',
        answer:
            'The fare for Ertiga On Rent in Navi Mumbai depends on whether you choose local, airport, or outstation travel. Skyline Cabs offers competitive and transparent pricing with no hidden charges. The final fare is clearly displayed before booking confirmation.',
    },
    {
        id: 3,
        question: 'Is Ertiga suitable for family travel?',
        answer:
            'Yes, Ertiga is one of the most preferred MPVs for family travel. It comfortably seats 6–7 passengers with sufficient luggage space. The spacious interior and smooth suspension ensure a relaxed and enjoyable journey.',
    },
    {
        id: 4,
        question: 'Can I book Ertiga for outstation trips from Navi Mumbai?',
        answer:
            'Absolutely. Our Ertiga On Rent in Navi Mumbai service is ideal for outstation destinations like Pune, Lonavala, Nashik, Mahabaleshwar, Kolhapur, and Shirdi. It offers comfort, fuel efficiency, and reliability for long-distance travel.',
    },
    {
        id: 5,
        question: 'Is Ertiga available for airport transfers in Navi Mumbai?',
        answer:
            'Yes, Skyline Cabs provides Ertiga On Rent in Navi Mumbai for airport pickup and drop services. The vehicle offers ample luggage capacity and comfortable seating, making airport transfers stress-free and convenient.',
    },
    {
        id: 6,
        question: 'Is online payment available for Ertiga rental?',
        answer:
            'Yes, Skyline Cabs supports secure online payments including UPI, debit cards, credit cards, and net banking. Booking confirmation is sent instantly once the payment is completed.',
    },
    {
        id: 7,
        question: 'Can I pre-book Ertiga in Navi Mumbai?',
        answer:
            'Yes, you can pre-book Ertiga On Rent in Navi Mumbai for weekends, holidays, weddings, corporate events, and family trips. Advance booking ensures vehicle availability and better travel planning.',
    },
    {
        id: 8,
        question: 'Is driver included with Ertiga rental?',
        answer:
            'Yes, every Ertiga rental with Skyline Cabs includes a professional and experienced driver. Our chauffeurs are trained, courteous, and familiar with Navi Mumbai roads and highways.',
    },
    {
        id: 9,
        question: 'Is Ertiga On Rent in Navi Mumbai available 24/7?',
        answer:
            'Yes, Skyline Cabs offers 24/7 Ertiga rental service in Navi Mumbai. Whether you need early morning travel or late-night pickup, we are available round the clock.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Ertiga On Rent in Navi Mumbai?',
        answer:
            'Skyline Cabs is trusted for Ertiga On Rent in Navi Mumbai because we provide clean vehicles, professional drivers, transparent pricing, punctual service, and 24x7 customer support. We focus on delivering affordable and comfortable travel experiences every time.',
    },
];



const someReviews = [
    {
        name: "Mr. Sagar More",
        rating: 5,
        review: "Booked Ertiga On Rent in Navi Mumbai for a family trip. The car was clean, comfortable, and spacious. Driver was polite and the journey was very smooth. Highly recommend Skyline Cabs!"
    },
    {
        name: "Mrs. Kavita Deshmukh",
        rating: 4,
        review: "Very satisfied with Ertiga rental service. Transparent pricing and punctual pickup. Skyline Cabs provides reliable and comfortable travel service in Navi Mumbai."
    },
]; 
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Navi Mumbai",
  "image": "https://skylinecabs.com/assets/images/ertiga-on-rent-navi-mumbai.jpg",
  "description": "Rent Ertiga in Navi Mumbai with Skyline Cabs for airport transfers, local trips, and outstation travel. Affordable and reliable Ertiga rental with driver available 24x7, including late night and early morning services.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/ertiga-on-rent-navi-mumbai"
  }
};


      


    return (
        <div>

<Helmet>
  <title>Ertiga On Rent in Navi Mumbai | Taxi & Outstation Rental | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Rent Ertiga in Navi Mumbai with Skyline Cabs for airport pickup, drop, local and outstation travel. Reliable 24x7 service with driver available for all trips including late night rentals." 
  />
  <meta 
    name="keywords" 
    content="ertiga on rent in navi mumbai, ertiga rental navi mumbai, ertiga hire in navi mumbai, ertiga car rental navi mumbai, ertiga taxi service navi mumbai, book ertiga on rent in navi mumbai, best ertiga on rent navi mumbai, cheapest ertiga rental navi mumbai, ertiga on rent with driver navi mumbai, ertiga rental service navi mumbai, ertiga airport pickup navi mumbai, ertiga airport drop navi mumbai, ertiga outstation rental navi mumbai, ertiga cab for outstation navi mumbai, 24x7 ertiga on rent in navi mumbai, late night ertiga rental navi mumbai, ertiga on rent in mumbai, ertiga car on rent in mumbai, ertiga cng on rent in mumbai, ertiga on hire in mumbai, ertiga rent per km in mumbai, Skyline Cabs Ertiga Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
    

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/128.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Ertigaonrentinnavimumbai;